function hoeheGesamt(element) {
    if (element === null) return 0;
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const height = element.offsetHeight;
    const margin = parseFloat(elementStyle.marginTop) + parseFloat(elementStyle.marginBottom);
    return height + margin;
}

function breiteGesamt(element) {
    if (element === null) return 0;
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const width = element.offsetWidth;
    const margin = parseFloat(elementStyle.marginRight) + parseFloat(elementStyle.marginLeft);
    return width + margin;
}

function getBorder(element) {
    if (element === null) return 0;
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    return {
        top: parseFloat(elementStyle.borderTopWidth),
        right: parseFloat(elementStyle.borderRightWidth),
        bottom: parseFloat(elementStyle.borderBottomWidth),
        left: parseFloat(elementStyle.borderLeftWidth)
    }
}

function getPadding(element) {
    if (element === null) return 0;
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    return {
        top: parseFloat(elementStyle.paddingTop),
        right: parseFloat(elementStyle.paddingRight),
        bottom: parseFloat(elementStyle.paddingBottom),
        left: parseFloat(elementStyle.paddingLeft)
    }
}

export {
    hoeheGesamt,
    breiteGesamt,
    getPadding,
    getBorder
}
